import {createSlice, PayloadAction, AnyAction} from '@reduxjs/toolkit';
import {ILocationsState} from 'modules/locations/types';
import {HYDRATE} from 'next-redux-wrapper';
import {IRootReducer} from 'core/redux/reducers';

export const locationsModuleName = 'locations';

const initialState: ILocationsState = {
    cities: [],
    isCityApplied: null,
    locationsList: [],
    userCityCode: null,
    userCityId: null,
};

export const locationsSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(HYDRATE, (state, action: AnyAction) => {
            const payload = action.payload as IRootReducer | undefined;
            if (!payload) {
                return state;
            }

            const locationsState = payload[locationsModuleName] as ILocationsState | undefined;
            if (!locationsState) {
                return state;
            }

            return {
                ...state,
                ...locationsState,
                cities: locationsState.cities?.length ? locationsState.cities : state.cities,
                locationsList: locationsState.locationsList?.length
                    ? locationsState.locationsList
                    : state.locationsList,
                userCityCode: locationsState.userCityCode || state.userCityCode,
                userCityId: locationsState.userCityId || state.userCityId,
                isCityApplied: locationsState.isCityApplied ?? state.isCityApplied,
            } as ILocationsState;
        });
    },
    initialState,
    name: locationsModuleName,
    reducers: {
        actionSetCities(state, {payload}: PayloadAction<ILocationsState['cities']>) {
            state.cities = payload;
        },

        actionSetIsCityApplied(state, {payload}: PayloadAction<ILocationsState['isCityApplied']>) {
            state.isCityApplied = payload;
        },

        actionSetLocationsList(state, {payload}: PayloadAction<ILocationsState['locationsList']>) {
            state.locationsList = payload;
        },

        actionSetUserLocationCode(state, {payload}: PayloadAction<ILocationsState['userCityCode']>) {
            state.userCityCode = payload;
        },

        actionSetUserLocationId(state, {payload}: PayloadAction<ILocationsState['userCityId'] | undefined>) {
            state.userCityId = payload;
        },
    },
});

export const {
    actions: {
        actionSetLocationsList,
        actionSetUserLocationId,
        actionSetIsCityApplied,
        actionSetCities,
        actionSetUserLocationCode,
    },
} = locationsSlice;

export const {reducer: locationsReducer} = locationsSlice;
